import { BankAccount } from '@cobra/interfaces-enums-mocks/interfaces';
import { fetchJson, fetchJsonPost } from '../../helpers';
import { Endpoint } from '../../constants';

const isValidBankAccount = async (checkoutId: number, bankAccount: BankAccount): Promise<boolean> => {
    try {
        return await fetchJsonPost(`${Endpoint.CHECKOUT}/${checkoutId}/customer/bank-account/validate`, bankAccount);
    } catch (error) {
        throw Error(`Could not validate bank account`);
    }
};
export const isValidIban = (checkoutId: number, iban: string) => isValidBankAccount(checkoutId, { iban, bic: null });

export const isCustomerNumberUnknownInAAX = async (telekomKdnr: string) => {
    try {
        return await fetchJsonPost(`${Endpoint.VALIDATION}/telekomkdnr`, { telekomKdnr });
    } catch (error) {
        throw Error('Could not validate customer number.');
    }
};

const isValidAreaCode = (lineType: string) => async (value: string) => {
    try {
        return await fetchJson<boolean>(`${Endpoint.VALIDATION}/area-code/${value}?lineType=${lineType}`);
    } catch (error) {
        throw Error(`Could not validate ${lineType} area code.`);
    }
};
export const isValidMobileAreaCode = isValidAreaCode('mobile');
export const isValidLandlineAreaCode = isValidAreaCode('landline');
